import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import "../fonts/Noto_Sans/NotoSans-Regular-normal.js";

export function generatePackagingPDF(list, pageTitle, filename, pageText) {
  if (!list || list.length === 0) return;

  const doc = new jsPDF({ unit: "mm", format: "a4" });

  // Set custom font and title
  doc.setFont("NotoSans-Regular", "normal");
  doc.setFontSize(16);
  doc.text(pageTitle, 14, 20);

  // Table headers
  const head = [
    [
      pageText.order,
      pageText.customer,
      pageText.pickupAddress,
      pageText.dropoffAddress,
    ],
  ];

  // Table data
  const body = list.map((item) => [
    item.p_id,
    item.customer_name || "",
    item.pickup_address || "",
    item.dropoff_address || "",
  ]);

  // Generate table
  autoTable(doc, {
    startY: 30,
    head,
    body,
    theme: "striped",
    styles: { font: "NotoSans-Regular", fontStyle: "normal", fontSize: 10 },
    headStyles: {
      font: "NotoSans-Regular",
      fontStyle: "normal",
      fillColor: [52, 73, 94],
      textColor: 255,
    },
  });

  // Save file
  doc.save(`${filename}.pdf`);
}
